/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chip, useTheme } from '@mui/material';
import { AppBar, Toolbar, IconButton, Menu } from '@material-ui/core';
import Button from '@mui/material/Button';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faBell, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import useStyles from './styles';
import { Typography } from '../Wrappers/Wrappers';
import sulogo from '../../assets/images/su-logo.svg';
import { logout } from '../../redux/Actions/login.action';
import { getUserInfo } from '../../redux/Actions/user.action';

export default function ClientHeader(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const theme = useTheme();
    const [profileMenu, setProfileMenu] = useState(null);
    const [hideButton, setHideButton] = useState(false);
    const [showSideBarToggle, setShowSideBarToggle] = useState(false);
    const { releaseName } = useSelector((state) => state.constants.settings);

    useEffect(() => {
        dispatch(getUserInfo());
        window.addEventListener('resize', handleWindowWidthChange);
        handleWindowWidthChange();
        return function cleanup() {
            window.removeEventListener('resize', handleWindowWidthChange);
        };
    }, [dispatch]);

    const signOut = () => {
        dispatch(logout(props.history));
    };

    useEffect(() => {
        if (props.history.location.pathname !== '/status-page') {
            setHideButton(true);
        } else {
            setHideButton(false);
        }
    }, [props.history.location.pathname]);

    function handleWindowWidthChange() {
        const windowWidth = window.innerWidth;
        const breakpointWidth = theme.breakpoints.values.sm;
        const isSmallScreen = windowWidth < breakpointWidth;
        if (isSmallScreen && !showSideBarToggle) {
            setShowSideBarToggle(true);
        } else if (!isSmallScreen && showSideBarToggle) {
            setShowSideBarToggle(false);
        }
    }

    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                <div>
                    <div className={classes.logotype}>
                        <Link to="/status-page">
                            <img
                                className={classes.logotypeIcon}
                                src={sulogo}
                                alt="logo"
                                width="160"
                            />
                        </Link>
                    </div>
                    <Chip
                        label={releaseName}
                        style={{
                            fontSize: '10px',
                            backgroundColor: '#7290F8',
                            color: 'white',
                            position: 'absolute',
                            bottom: '8px'
                        }}
                        className={classes.headerVersion}
                    />
                </div>
                <div className={classes.grow} />
                {hideButton ? (
                    <Button
                        onClick={() => {
                            props.history.push('/status-page');
                        }}
                        className={classes.BackButton}
                    >
                        <span> Back to Report</span>
                    </Button>
                ) : (
                    <>
                        <Button
                            onClick={() => {
                                props.history.push('/status-page/emails');
                            }}
                            className={classes.headerMenuNoti}
                        >
                            <FontAwesomeIcon
                                icon={faBell}
                                color="white"
                                className={classes.fontAwesomeIcon}
                                classes={{ root: classes.headerIcon }}
                            />
                            {!showSideBarToggle ? (
                                <span className={classes.buttonText}> Get Notification</span>
                            ) : (
                                ''
                            )}
                        </Button>
                        {/* <IconButton
                            color="inherit"
                            aria-haspopup="true"
                            aria-controls="mail-menu"
                            onClick={(e) => {
                                setNotificationsMenu(e.currentTarget);
                                setIsNotificationsUnread(false);
                            }}
                            className={classes.headerMenuButton}
                        >
                            <Badge
                                badgeContent={isNotificationsUnread ? '' : null}
                                color="warning"
                                className={classes.unreadBadge}
                            >
                                <FontAwesomeIcon
                                    icon={faBell}
                                    color="black"
                                    className={classes.fontAwesomeIcon}
                                    classes={{ root: classes.headerIcon }}
                                />
                            </Badge>
                        </IconButton>
                        <Menu
                            id="notifications-menu"
                            open={Boolean(notificationsMenu)}
                            anchorEl={notificationsMenu}
                            onClose={() => setNotificationsMenu(null)}
                            className={classes.headerMenu}
                            disableAutoFocusItem
                        >
                            {notifications.map((notification) => (
                                <MenuItem
                                    key={notification.id}
                                    onClick={() => setNotificationsMenu(null)}
                                    className={classes.headerMenuItem}
                                >
                                    <Notification {...notification} typographyVariant="inherit" />
                                </MenuItem>
                            ))}
                        </Menu> */}
                        <IconButton
                            aria-haspopup="true"
                            color="inherit"
                            className={classes.headerMenuButton}
                            aria-controls="profile-menu"
                            onClick={(e) => setProfileMenu(e.currentTarget)}
                        >
                            <FontAwesomeIcon
                                icon={faUserCircle}
                                color="#BEC2CE"
                                className={classes.fontAwesomeUserIcon}
                                classes={{ root: classes.headerIcon }}
                            />
                            {!showSideBarToggle ? (
                                <span className={classes.clientName}>
                                    {Cookies.get('name') && Cookies.get('name').length > 0
                                        ? Cookies.get('name')
                                        : ''}
                                </span>
                            ) : (
                                ''
                            )}
                        </IconButton>
                    </>
                )}
                <Menu
                    id="profile-menu"
                    open={Boolean(profileMenu)}
                    anchorEl={profileMenu}
                    onClose={() => setProfileMenu(null)}
                    className={classes.headerMenu}
                    classes={{ paper: classes.profileMenu }}
                    disableAutoFocusItem
                >
                    {showSideBarToggle ? (
                        <span className={classes.clientName}>
                            {Cookies.get('name') && Cookies.get('name').length > 0
                                ? Cookies.get('name')
                                : ''}
                        </span>
                    ) : (
                        ''
                    )}
                    <div className={classes.profileMenuUser}>
                        <Typography
                            className={classes.profileMenuLink}
                            color="primary"
                            onClick={signOut}
                        >
                            Sign Out
                        </Typography>
                    </div>
                </Menu>
            </Toolbar>
        </AppBar>
    );
}
